// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.photos.RentalManagerUserPropertyPhotoWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyPhotoWebApiHandler_caption,
  RentalManagerUserPropertyPhotoWebApiHandler_delete,
  RentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl,
  RentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl_Path,
  RentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds,
  RentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds_Path,
  RentalManagerUserPropertyPhotoWebApiHandler_rank,
  RentalManagerUserPropertyPhotoWebApiHandler_upload,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  UpdatePropertyPhotoRankRequestWebDto,
  UserPropertyFloorPlanPhotoUploadRequestWebDto,
  UserPropertyPhotoGenerateUploadUrlRequestWebDto,
  UserPropertyPhotoPollPhotoIdsResponseWebDto,
  UserPropertyPhotoUploadResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface CaptionParams {
  caption?: string;
  photoId: string;
}
interface DeleteParams {
  photoId: string;
}
interface PollPhotoIdsParams {
  listingAlias: ListingAlias;
}
interface RankParams {
  listingAlias: ListingAlias;
}
interface UploadParams {
  listingAlias: ListingAlias;
  sourceUrl?: string;
}

export interface RentalManagerUserPropertyPhotoWebApiHandler_caption_Args {
  getParams: CaptionParams;
}

export type RentalManagerUserPropertyPhotoWebApiHandler_caption_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyPhotoWebApiHandler_caption_Args
>;

/**
 * Update a photo caption
 * @deprecated
 */
export const useRentalManagerUserPropertyPhotoWebApiHandler_caption = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyPhotoWebApiHandler_caption_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyPhotoWebApiHandler_caption_Args) =>
      RentalManagerUserPropertyPhotoWebApiHandler_caption(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyPhotoWebApiHandler_delete_Args {
  getParams: DeleteParams;
}

export type RentalManagerUserPropertyPhotoWebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyPhotoWebApiHandler_delete_Args
>;

/**
 * Delete a property photo
 * @deprecated
 */
export const useRentalManagerUserPropertyPhotoWebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyPhotoWebApiHandler_delete_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyPhotoWebApiHandler_delete_Args) =>
      RentalManagerUserPropertyPhotoWebApiHandler_delete(args.getParams, httpClient),
  });
};

export type RentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl_Options = UseQueryOptions<
  string,
  unknown,
  string,
  readonly [string, UserPropertyPhotoGenerateUploadUrlRequestWebDto]
>;

const RentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl_GetKey = (
  postData: UserPropertyPhotoGenerateUploadUrlRequestWebDto,
) => [RentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl_Path, postData] as const;

export const RentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl_queryOptions = (
  postData: UserPropertyPhotoGenerateUploadUrlRequestWebDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl_GetKey(postData),
    queryFn: () => RentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Generate a time-limited photo upload URL for the QR-code phone upload flow
 */
export const useRentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl = (
  postData: UserPropertyPhotoGenerateUploadUrlRequestWebDto,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl.getKey =
  RentalManagerUserPropertyPhotoWebApiHandler_generateUploadUrl_GetKey;

export type RentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds_Options = UseQueryOptions<
  UserPropertyPhotoPollPhotoIdsResponseWebDto,
  unknown,
  UserPropertyPhotoPollPhotoIdsResponseWebDto,
  readonly [string, PollPhotoIdsParams]
>;

const RentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds_GetKey = (getParams: PollPhotoIdsParams) =>
  [RentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds_Path, getParams] as const;

export const RentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds_queryOptions = (
  getParams: PollPhotoIdsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * List the encoded photo ids of a listing, for the QR upload flow to poll for changes
 */
export const useRentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds = (
  getParams: PollPhotoIdsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds.getKey =
  RentalManagerUserPropertyPhotoWebApiHandler_pollPhotoIds_GetKey;

export interface RentalManagerUserPropertyPhotoWebApiHandler_rank_Args {
  getParams: RankParams;
  postData: UpdatePropertyPhotoRankRequestWebDto;
}

export type RentalManagerUserPropertyPhotoWebApiHandler_rank_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyPhotoWebApiHandler_rank_Args
>;

/**
 * Update the rank of photos
 * @deprecated
 */
export const useRentalManagerUserPropertyPhotoWebApiHandler_rank = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyPhotoWebApiHandler_rank_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyPhotoWebApiHandler_rank_Args) =>
      RentalManagerUserPropertyPhotoWebApiHandler_rank(args.getParams, args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyPhotoWebApiHandler_upload_Args {
  getParams: UploadParams;
  postData: UserPropertyFloorPlanPhotoUploadRequestWebDto;
}

export type RentalManagerUserPropertyPhotoWebApiHandler_upload_Options = UseMutationOptions<
  UserPropertyPhotoUploadResponseWebDto,
  unknown,
  RentalManagerUserPropertyPhotoWebApiHandler_upload_Args
>;

/**
 * Upload a property photo
 */
export const useRentalManagerUserPropertyPhotoWebApiHandler_upload = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyPhotoWebApiHandler_upload_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyPhotoWebApiHandler_upload_Args) =>
      RentalManagerUserPropertyPhotoWebApiHandler_upload(args.getParams, args.postData, httpClient),
  });
};
